import { createGlobalStyle } from 'styled-components';

import RubikBold from '~/assets/fonts/Rubik/Rubik-Bold.ttf';
import RubikItalic from '~/assets/fonts/Rubik/Rubik-Italic.ttf';
import RubikLight from '~/assets/fonts/Rubik/Rubik-Light.ttf';
import RubikMedium from '~/assets/fonts/Rubik/Rubik-Medium.ttf';
import Rubik from '~/assets/fonts/Rubik/Rubik-Regular.ttf';
import RubikSemiBold from '~/assets/fonts/Rubik/Rubik-SemiBold.ttf';

export default createGlobalStyle`
  @font-face {
    font-family: 'Rubik';
    src: local('Rubik'),
        url(${Rubik}) format('truetype');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'RubikBold';
    src: local('RubikBold'),
        url(${RubikBold}) format('truetype');
    font-weight: bold;
    font-style: normal;
  }
  @font-face {
    font-family: 'RubikMedium';
    src: local('RubikMedium'),
        url(${RubikMedium}) format('truetype');
    font-weight: 400;
    font-style: normal;
  }
  @font-face {
    font-family: 'RubikSemiBold';
    src: local('RubikSemiBold'),
        url(${RubikSemiBold}) format('truetype');
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: 'RubikLight';
    src: local('RubikLight'),
        url(${RubikLight}) format('truetype');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'RubikItalic';
    src: local('RubikItalic'),
        url(${RubikItalic}) format('truetype');
    font-weight: normal;
    font-style: italic;
  }

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
   -webkit-overflow-scrolling: touch;
  }

  *:focus {
    outline: 0;
  }

  .react-pdf__Document {
    height: auto !important;
    width: 100%;
    background: gray !important;
  }

  .react-pdf__Page__textContent {
    user-select: none;
    display: none;
  }

  .react-pdf__Page__svg {
    height: auto !important;
    width: 85% !important;
    margin: 35px 8% 0px !important;
    margin-bottom: 60px !important;
    background: white !important;
    svg {
      width: 80% !important;
      height: auto !important;
    }
  }

  .react-pdf__Page__canvas {
    height: auto !important;
    width: 85% !important;
    margin: 35px 8% 0px !important;
    margin-bottom: 60px !important;
    background: white !important;
    svg {
      width: 80% !important;
      height: auto !important;
    }
  }

  .react-pdf__message.react-pdf__message--error {
    display: none;
}

  html, body, #root {
    /* overflow: hidden; */
    margin: 0 auto;
    position: relative;
    height: 100%;
    overflow: auto;
    background: #ececec;
    -webkit-overflow-scrolling: touch
  }

  body {
  ::-webkit-scrollbar {
    width: 16px;
  }
  ::-webkit-scrollbar-track {
    background-color: #fff;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #babac0;
    border-radius: 16px;
    border: 4px solid #fff;
  }
  ::-webkit-scrollbar-button {
    display: none;
  }
  }

  body, input, button {
    font: 16px Rubik, sans-serif;
  }

  a {
    text-decoration: none;
  }

  label {
    font-size: 14px;
    min-height: 25px;
  }

  ul {
    list-style: none;
  }

  button {
    cursor: pointer;
  }
`;
